import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoaderService } from '../../../core/services/loader/loader.service';

@Component({
  selector: 'dc-smile-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './smile-loader.component.html',
  styleUrl: './smile-loader.component.scss'
})
export class SmileLoaderComponent {
  loader = inject(LoaderService);
}
